import * as yup from 'yup';

function name(formatMessage, isEdit) {
  if (isEdit) {
    return yup.string();
  }
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_INSIGHTCONFIG_NAME_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      100,
      formatMessage({
        id: 'CREATEFORM_INSIGHTCONFIG_NAME_MAX',
        defaultMessage: 'Name must be 100 characters or less',
      }),
    );
}

function value(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_INSIGHTCONFIG_VALUE_REQUIRED',
      defaultMessage: 'Value is required',
    }),
  );
}

function description(formatMessage) {
  return yup
    .string()
    .max(
      100,
      formatMessage({
        id: 'CREATEFORM_INSIGHTCONFIG_DESCRIPTION_MAX',
        defaultMessage: 'Description must be 100 characters or less',
      }),
    )
    .nullable();
}

const validationSchema = (formatMessage, isEdit) =>
  yup
    .object({
      name: name(formatMessage, isEdit),
      value: value(formatMessage),
      description: description(formatMessage),
    })
    .required();

export default validationSchema;
